import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Lucía Hernández',
    location: 'Phoenix, AZ',
    photo: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?auto=format&fit=facearea&facepad=2.5&w=300&h=300&q=80',
    text: 'Llevaba 8 meses sin poder dejar de stalkearlo. Cada noche revisaba su Instagram. En el día 10 hice el ritual de "Limpieza de Huellas" y por primera vez dormí sin pensar en él. Hoy ya no me importa lo que publica.'
  }, {
    name: 'Mariana Castillo',
    location: 'Orlando, FL',
    photo: 'https://images.unsplash.com/photo-1592621385612-4d7129426394?auto=format&fit=facearea&facepad=2.5&w=300&h=300&q=80',
    text: 'Esperaba esa llamada de explicación que nunca iba a llegar. Este sistema me dio el cierre que él nunca me dio. Soy madre soltera, recuperé mi energía para mis hijos y para mí. Volví a sentirme entera.'
  }, {
    name: 'Renata Vásquez',
    location: 'San Antonio, TX',
    photo: 'https://images.unsplash.com/photo-1573497019418-b400bb3ab074?auto=format&fit=facearea&facepad=2.5&w=300&h=300&q=80',
    text: 'Después de un matrimonio de 7 años no sabía quién era yo sin él. Las frases de cierre fueron mi salvavidas. Hoy entiendo que su ausencia no me rompió, me devolvió a mí. Volví a escribir, a reírme, a vivir.'
  }];
  return <section className="py-24 px-4 bg-blush" data-id="element-319">
      <div className="max-w-6xl mx-auto" data-id="element-320">
        <div className="text-center mb-16" data-id="element-321">
          <span className="font-sans text-accent text-xs font-bold tracking-[0.25em] uppercase mb-3 block" data-id="element-322">
            ✦ Historias Reales ✦
          </span>
          <h2 className="font-serif font-bold text-3xl md:text-5xl text-primary mb-4" data-id="element-323">
            Mujeres que ya volvieron a sí mismas
          </h2>
          <p className="font-sans text-ink/60 text-sm italic" data-id="element-324">
            *Testimonios de mujeres que han completado el proceso.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-325">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-xl border border-soft/30 flex flex-col relative hover:-translate-y-1 transition-transform" data-id="element-326">
              <Quote className="absolute top-6 right-6 text-soft/60" size={32} data-id="element-327" />

              <div className="flex items-center gap-4 mb-5" data-id="element-328">
                <div className="relative" data-id="element-329">
                  <img src={t.photo} alt={t.name} className="w-16 h-16 rounded-full object-cover border-4 border-blush shadow-md" data-id="element-330" />
                  <div className="absolute -bottom-1 -right-1 bg-relief text-white rounded-full p-1 border-2 border-white" data-id="element-331">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20" data-id="element-332">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-333" />
                    </svg>
                  </div>
                </div>
                <div data-id="element-334">
                  <p className="font-sans font-bold text-primary text-base" data-id="element-335">
                    {t.name}
                  </p>
                  <p className="font-sans text-xs text-ink/55" data-id="element-336">{t.location}</p>
                  <div className="flex text-gold mt-1" data-id="element-337">
                    {[...Array(5)].map((_, i) => <Star key={i} size={11} fill="currentColor" data-id="element-338" />)}
                  </div>
                </div>
              </div>

              <p className="text-ink/80 font-sans italic leading-relaxed grow text-sm md:text-base border-t border-soft/30 pt-5" data-id="element-339">
                "{t.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}